import { resolveRouteByPath } from './trackConfig.js'

/**
 * path → { moduleCode, pageCode }
 * 配置表路由优先，本地目录作配置接口失败时的兜底。
 * @param {string} path 路由 path
 * @returns {{ moduleCode: string, pageCode: string } | null}
 */
export function resolveTrackMeta(path) {
  return resolveRouteByPath(path)
}



// WEBPACK FOOTER //
// ./src/utils/track/modules.js